import type { CreateFilterText } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

export const getFiltersFromUrl = (
	filterText: string | null | undefined
): CreateFilterText => {
	const result: CreateFilterText = {
		allParametrics: [],
		selectedFilters: {}
	};

	if (!filterText) {
		return result;
	}

	const filterGroups = filterText.split(";").filter(Boolean);
	filterGroups.forEach((group) => {
		const [type, values] = group.split("|") as [FilterTypes, string];

		if (!type || !values) return;

		switch (type) {
			case FilterTypes.PARAMETRIC: {
				if (!result.selectedFilters[FilterTypes.PARAMETRIC]) {
					result.selectedFilters[FilterTypes.PARAMETRIC] = {};
				}

				const valueList = values.split("*");
				valueList.forEach((value) => {
					const match = value.match(/^[LM](\d+)_(\d+)$/);
					if (match) {
						const [, parametricId, id] = match;

						if (parametricId && id) {
							const paramId = parseInt(parametricId, 10);
							const filterId = parseInt(id, 10);

							if (!result.selectedFilters[FilterTypes.PARAMETRIC]) {
								result.selectedFilters[FilterTypes.PARAMETRIC] = {};
							}

							if (!result.selectedFilters[FilterTypes.PARAMETRIC][paramId]) {
								result.selectedFilters[FilterTypes.PARAMETRIC][paramId] = [];
							}

							if (
								!result.selectedFilters[FilterTypes.PARAMETRIC][
									paramId
								].includes(filterId)
							) {
								result.selectedFilters[FilterTypes.PARAMETRIC][paramId].push(
									filterId
								);
							}
						}
					}
				});
				break;
			}

			case FilterTypes.PRICE: {
				const match = values.match(/^true_(\d+)-(\d+)$/);
				if (match) {
					const [, min, max] = match;

					if (min && max) {
						result.selectedFilters[FilterTypes.PRICE] = [
							parseInt(min, 10),
							parseInt(max, 10)
						];
					}
				}
				break;
			}

			case FilterTypes.CATEGORY:
			case FilterTypes.MANUFACTURER:
			case FilterTypes.ONHAND:
			case FilterTypes.FLAG: {
				const ids = values
					.split(",")
					.map((id) => parseInt(id.trim(), 10))
					.filter((id) => !isNaN(id));

				if (ids.length > 0) {
					result.selectedFilters[type] = ids;
				}
				break;
			}

			default:
				console.warn(`Unknown filter type: ${type}`);
				break;
		}
	});

	return result;
};
